/* eslint-disable prefer-arrow-callback */
/* eslint-disable prefer-template */
/**
 * Layer Type: HP Masthead Slider
 *
 * @package  embark
 * @since    1.0.0
 */

/**
 * Import dependencies.
 */
import $ from 'jquery';
import 'slick-carousel';

/**
 * Slider layers
 *
 * @type {NodeList}
 */
const blockHPSlider = document.querySelectorAll('.hp-masthead-slider');

// update prev/next labels.
function updateHPSliderLabels() {
	const currIndex = $('.slick-active').data('slick-index');
	const nextIndex = currIndex + 1;
	const prevIndex = currIndex - 1;

	$('.hp-masthead-slider__prev .text').html($('.slick-slide[data-slick-index="' + prevIndex + '"]').find('.slide-overlay').data('title'));
	$('.hp-masthead-slider__next .text').html($('.slick-slide[data-slick-index="' + nextIndex + '"]').find('.slide-overlay').data('title'));

	// console.log('Prev: ' + $('.slick-slide[data-slick-index="' + prevIndex + '"]').find('.hp-masthead-slider__slide').data('title'));
	// console.log('Next: ' + $('.slick-slide[data-slick-index="' + nextIndex + '"]').find('.hp-masthead-slider__slide').data('title'));
}

/**
 * Do synchronized slick sliders.
 */
function initBlockHPSlider() {
	$(blockHPSlider).each(
		function () {
			// This layer instance.
			// const $this = $(this);

			// This layer's content slider.
			const $slider = $(this).find('.hp-masthead-slider__slides');

			if (($slider.find('.hp-masthead-slider__slide').length <= 1)) {
				// remove arrows
				$('.hp-masthead-slider__navigation').hide();
			}

			// Initialize slider if more than one slide.
			if ($slider.find('.hp-masthead-slider__slide').length >= 2) {
				// Content slider properties.
				const sliderProps = {
					adaptiveHeight: true,
					arrows: null,
					dots: false,
					draggable: true,
					fade: false,
					autoplay: true,
					autoplaySpeed: 8000,
					pauseOnHover: true,
				};

				// Initialize the content slider.
				$slider.slick(sliderProps);

				updateHPSliderLabels();

				// Custom prev/next links.
				$('.hp-masthead-slider__next').on('click', function () {
					$slider.slick('slickNext');
					updateHPSliderLabels();
				});

				$('.hp-masthead-slider__prev').on('click', function () {
					$slider.slick('slickPrev');
					updateHPSliderLabels();
				});

				$slider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
					const currentVideo = slick.$slides[currentSlide].querySelector('video');
					if (currentVideo) {
						currentVideo.pause();
					}

					const nextVideo = slick.$slides[nextSlide].querySelector('video');
					if (nextVideo) {
						if (!nextVideo.getAttribute('src')) {
							nextVideo.setAttribute('src', nextVideo.dataset.src);
						}
						nextVideo.play();
					}
				});

				// On after slide change
				$slider.on('afterChange', function () {
					updateHPSliderLabels();
				});

				// On hover, pause.
				$slider.on('mouseover', function () {
					$slider.slick('pause');
				});

				// On hover, pause.
				$slider.on('mouseout', function () {
					$slider.slick('play');
				});
			}
		},
	);
}

window.addEventListener('DOMContentLoaded', initBlockHPSlider);
